// The agents picker (users, 23 Oct 2026: "agents can have custom images and avatars"): Automatic · Icon · Emblem as one segmented
// control beside the look, each option with the Librarian drawn its way at 16 px and its name. It
// writes the person's `pref:ui.agentFace`; Automatic follows the look (the tile in Classic, the Emblem in Signature and Aurora). WP-SHELL.
import { useTranslation } from "@ncp/i18n";
import { FACE_CHOICES, type FaceChoice } from "../theme";
import { ModuleDisc, SegmentedControl } from "../theme/primitives";
import { LazyAgentFace } from "../brand/LazyAgentFace";
import { useDisplaySettings } from "../prefs";

function Preview({ choice }: { choice: FaceChoice }) {
  if (choice === "auto") return null;
  if (choice === "icon") return <ModuleDisc module="kb" size={16} />;
  return <LazyAgentFace agent="kb" size={16} />;
}

/** The row of the account panel and of Accessibility and display: the person's faces. */
export function FaceRow() {
  const { t } = useTranslation();
  const { faces, setFaces } = useDisplaySettings();
  const name = (c: FaceChoice) => t(`assistant:econic.shell.faces.${c}`);
  return (
    <div className="row3" data-econic-faces="">
      <span className="lb">{t("assistant:econic.shell.faces.title")}</span>
      <SegmentedControl<FaceChoice>
        label={t("assistant:econic.shell.faces.title")}
        value={faces}
        onChange={setFaces}
        options={FACE_CHOICES.map((c) => ({
          value: c,
          label: (
            <span className="ec-face-opt">
              <Preview choice={c} />
              <span>{name(c)}</span>
            </span>
          ),
          ariaLabel: name(c),
        }))}
      />
    </div>
  );
}
